import { Feature as m } from "./atoms-v21129.js";
import "./atoms-v2886.js";
import { hover as s } from "./atoms-v21111.js";
import { extractEventInfo as u } from "./atoms-v2998.js";
import { frame as c } from "./atoms-v2949.js";
function i(o, t, r) {
  const { props: e } = o;
  o.animationState && e.whileHover && o.animationState.setActive("whileHover", r === "Start");
  const a = "onHover" + r, n = e[a];
  n && c.postRender(() => n(t, u(t)));
}
class H extends m {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = s(t, (r) => (i(this.node, r, "Start"), (e) => i(this.node, e, "End"))));
  }
  unmount() {
  }
}
export {
  H as HoverGesture
};
